/**
 * src/lib/motTrang.js — bản một trang: tài liệu founder cầm đi được.
 *
 * ─────────────────────────────────────────────────────────────────────────
 * HAI BẢN, KHÁC NHAU Ở NỘI DUNG CHỨ KHÔNG PHẢI Ở GIAO DIỆN
 *
 * 'nha-dau-tu' — gửi ra ngoài. KHÔNG có danh sách quỹ đang theo dõi và
 *   KHÔNG có checklist nội bộ. Gửi cho quỹ A một trang ghi rõ mình đang nhắm
 *   quỹ B, C, D là tự làm yếu vị thế đàm phán; còn checklist còn dở là việc
 *   nhà của founder, không phải thứ để người ngoài chấm điểm.
 *
 * 'noi-bo' — đọc với đồng sáng lập, có đủ mọi thứ.
 *
 * MỘT NGUYÊN TẮC PHẢI GIỮ: đây là bản TỰ KHAI. Mọi con số do doanh nghiệp tự
 * nhập và tự chịu trách nhiệm; fundraising.vn không thẩm định gì cả. Nếu tài
 * liệu này trông giống một chứng nhận, người nhận sẽ đọc nhầm điểm số thành
 * đánh giá của bên thứ ba — và đó là thiệt hại cho cả hai phía. Vì vậy dòng
 * "doanh nghiệp tự khai" nằm ngay dưới tiêu đề, không phải ở chân trang.
 *
 * Là file HTML một mình, không phụ thuộc mạng: logo nhúng thẳng dạng data URL,
 * CSS nằm trong file. Mở offline vẫn đủ, in ra PDF vẫn đúng khổ A4.
 *
 * KHÔNG tạo link chia sẻ công khai. Trang này có runway, cổ phần, định giá —
 * đưa lên URL ai có link cũng xem được là mời rò rỉ. Chia sẻ ở đây là chia sẻ
 * FILE, founder tự chọn người nhận.
 * ─────────────────────────────────────────────────────────────────────────
 */

import { TOOLS } from '../data/tools.js';
// Đường dẫn tương đối thay vì alias @shared để bộ kiểm thử chạy bằng Node thuần
// import được file này — đây là chỗ đáng kiểm thử nhất vì nó quyết định thông tin
// nào rời khỏi máy người dùng.
import { label } from '../../shared/taxonomy.js';
import { nhanNguon, GIAI_THICH_TAI_LIEU } from '../../shared/nguonSo.js';

function thoat(s) {
  return String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

const nhan = (mien, gt) => (gt ? label(mien, gt) || gt : '');

const TEN_TP = {
  HCM: 'TP. Hồ Chí Minh', HN: 'Hà Nội', DN: 'Đà Nẵng', HP: 'Hải Phòng',
  CT: 'Cần Thơ', BD: 'Bình Dương', DNAI: 'Đồng Nai', KHAC: 'Việt Nam',
};

/**
 * DANH SÁCH CHO PHÉP: chỉ những công cụ nêu ở đây mới được xuất ra bản gửi
 * nhà đầu tư.
 *
 * ─────────────────────────────────────────────────────────────────────────
 * PHẢI LÀ DANH SÁCH CHO PHÉP, KHÔNG PHẢI DANH SÁCH CHẶN.
 *
 * Bản trước dùng danh sách chặn và chỉ chặn mỗi `readiness-score`. Hậu quả:
 * bản nháp `fund-match` — tức DANH SÁCH QUỸ founder đang nhắm tới — vẫn đi
 * thẳng vào tài liệu gửi cho quỹ, đúng thứ mà chính file này nói không được
 * gửi. Với danh sách chặn, mỗi công cụ mới thêm vào sản phẩm là một lần rò
 * mặc định; với danh sách cho phép, công cụ mới mặc định nằm ngoài cho tới
 * khi có người cân nhắc và thêm vào đây.
 *
 * Tiêu chí để một công cụ được nằm trong danh sách này: kết quả của nó là
 * thứ founder CHỦ ĐỘNG muốn nhà đầu tư đọc, và không tiết lộ vị thế đàm phán.
 * Vì vậy không có ở đây:
 *  - fund-match: để lộ mình đang nhắm quỹ nào khác
 *  - term-sheet: để lộ điều khoản đang đàm phán với một quỹ cụ thể
 *  - valuation-preseed, valuation-revenue: để lộ mức định giá mình kỳ vọng trước khi đàm phán
 *  - round-simulator, safe-convert, founder-equity-split: kịch bản pha loãng
 *    và chia cổ phần nội bộ
 *  - readiness-score: điểm tự chấm, không thuyết phục người ngoài
 *  - legal-checklist, pitch-deck: việc nhà còn dở
 * ─────────────────────────────────────────────────────────────────────────
 */
export const XUAT_CHO_NHA_DAU_TU = new Set([
  'growth-metrics',
  'runway',
  'unit-economics-check',
  'market-sizing',
  'raise-planner',
  'cap-table',
]);

const CONG_VIEC = [
  'Rà soát mức sẵn sàng gọi vốn',
  'Xác định số vốn và mục tiêu sử dụng',
  'Kiểm tra pitch deck và giấy tờ',
];

/** Dòng chỉ có số, phần trăm hoặc đơn vị — tức là GIÁ TRỊ của dòng nhãn ngay trên. */
function laGiaTri(dong) {
  return /^[+\-]?[\d.,]+\s*(%|\/\s*100|tháng|năm|tỷ|triệu|đ|vnđ|vnd|x|lần)?$/i.test(dong.trim());
}

/**
 * Kết quả công cụ được lưu bằng cách cào chữ từ màn hình (innerText), nên nhãn
 * và số nằm ở hai dòng riêng và thụt lề tuỳ bố cục. Đổ thẳng vào tài liệu là ra
 * một mớ lộn xộn. Hàm này ghép "nhãn + giá trị" thành từng cặp để trình bày
 * được thành bảng.
 *
 * @returns {Array<{nhan: string, giaTri: string}>} giaTri rỗng nghĩa là dòng
 *   chữ đứng một mình (câu nhận xét), không phải cặp nhãn-giá trị.
 */
export function tachDong(text) {
  const dong = String(text || '')
    .split('\n')
    .map((d) => d.trim())
    .filter(Boolean);
  const ra = [];
  for (const d of dong) {
    const truoc = ra[ra.length - 1];
    if (laGiaTri(d) && truoc && !truoc.giaTri && truoc.nhan.length <= 60) {
      truoc.giaTri = d;
    } else {
      ra.push({ nhan: d, giaTri: '' });
    }
  }
  return ra;
}

/** Tên file an toàn trên Windows lẫn máy Mac, bỏ dấu tiếng Việt. */
export function tenFileAnToan(goc, duoi) {
  const s = String(goc || 'Ban-mot-trang')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd').replace(/Đ/g, 'D')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60) || 'Ban-mot-trang';
  return `${s}.${duoi}`;
}

function bangHtml(hang) {
  if (!hang.length) return '';
  return `<table>${hang
    .map(([k, v]) => `<tr><th scope="row">${thoat(k)}</th><td>${thoat(v)}</td></tr>`)
    .join('')}</table>`;
}

function khoiKetQua(drafts, guiRaNgoai) {
  return drafts.map(([ten, d]) => {
    const cap = tachDong(d.summary);
    if (!cap.length) return '';
    const co = cap.filter((x) => x.giaTri);
    const chu = cap.filter((x) => !x.giaTri);
    const coDiem = co.some((x) => /\/\s*100|%/.test(x.giaTri));
    return `<section class="kq-khoi">
      <h3>${thoat(ten)}</h3>
      ${co.length ? `<table>${co.map((x) => `<tr><th scope="row">${thoat(x.nhan)}</th><td>${thoat(x.giaTri)}</td></tr>`).join('')}</table>` : ''}
      ${chu.length ? `<ul class="ghi-chu">${chu.slice(0, 6).map((x) => `<li>${thoat(x.nhan)}</li>`).join('')}</ul>` : ''}
      ${!guiRaNgoai && coDiem ? '<p class="ghi-chu">Điểm do doanh nghiệp tự chấm theo bảng tiêu chí công khai tại fundraising.vn, dựa trên dữ liệu tự khai. Không phải đánh giá của bên thứ ba.</p>' : ''}
    </section>`;
  }).join('');
}

/**
 * Chọn nội dung cho bản một trang.
 *
 * ─────────────────────────────────────────────────────────────────────────
 * VÌ SAO TÁCH RIÊNG KHỎI PHẦN VẼ: có hai đầu ra (HTML và PDF) và sẽ còn thêm.
 * Nếu mỗi đầu ra tự quyết định lấy gì thì sớm muộn chúng lệch nhau — và lần
 * lệch đầu tiên nhiều khả năng là ở đúng chỗ nguy hiểm nhất: danh sách cho
 * phép. Một bản rò, một bản không, mà test chỉ soi một bản.
 *
 * Nên quy tắc "cái gì được rời khỏi máy người dùng" nằm ở ĐÚNG MỘT chỗ là
 * hàm này. Phần vẽ chỉ nhận kết quả và trình bày.
 * ─────────────────────────────────────────────────────────────────────────
 *
 * @param {object} data Bản chuẩn bị
 * @param {'nha-dau-tu'|'noi-bo'} [cheDo]
 */
export function noiDungMotTrang(data, cheDo = 'nha-dau-tu') {
  const p = (data && data.profile) || {};
  const guiRaNgoai = cheDo !== 'noi-bo';
  const ngay = new Date().toLocaleDateString('vi-VN');

  const coBan = [
    ['Giai đoạn sản phẩm', nhan('PRODUCT_STAGE', p.productStage)],
    ['Khách hàng chính', nhan('CUSTOMER_TYPE', p.customerType)],
    ['Năm thành lập', p.namThanhLap || ''],
    ['Quy mô đội ngũ', p.soNhanSu ? `${p.soNhanSu} người` : ''],
    ['Trụ sở', TEN_TP[p.city] || ''],
    ['Website', p.website || ''],
    ['Email', p.emailLienHe || ''],
  ].filter(([, v]) => v);

  const doiNgu = (Array.isArray(p.doiNgu) ? p.doiNgu : [])
    .filter((n) => n && n.ten)
    .map((n) => [
      n.vaiTro ? `${n.ten}, ${n.vaiTro}` : n.ten,
      [
        n.toanThoiGian ? 'Toàn thời gian' : 'Bán thời gian',
        n.namNganh ? `${n.namNganh} năm trong ngành` : '',
      ].filter(Boolean).join(', '),
    ]);

  const drafts = Object.entries((data && data.drafts) || {})
    // Bản gửi ra ngoài: chỉ giữ công cụ trong danh sách cho phép.
    .filter(([id]) => !guiRaNgoai || XUAT_CHO_NHA_DAU_TU.has(id))
    .map(([id, d]) => [TOOLS.find((t) => t.toolId === id)?.title, d, id])
    .filter(([t, d]) => t && d);

  const khoiKq = drafts.map(([ten, d, id]) => {
    const cap = tachDong(d.summary);
    return {
      ten,
      // Nguồn và ngày của khối số: nhà đầu tư cần biết số lấy từ đâu, tính lúc nào.
      nguon: nhanNguon(p.nguonSo?.[id], d.updated),
      hang: cap.filter((c) => c.giaTri).map((c) => [c.nhan, c.giaTri]),
      ghiChu: cap.filter((c) => !c.giaTri).slice(0, 6).map((c) => c.nhan),
      coDiem: cap.some((c) => /\/\s*100|%/.test(c.giaTri)),
    };
  }).filter((k) => k.hang.length || k.ghiChu.length);

  const muc = [];
  if (coBan.length) muc.push({ h: 'Thông tin cơ bản', kieu: 'bang', hang: coBan });
  if (doiNgu.length) muc.push({ h: 'Đội ngũ sáng lập', kieu: 'bang', hang: doiNgu });
  if (p.dungVon || p.cotMoc) {
    muc.push({
      h: 'Sử dụng vốn',
      kieu: 'hon-hop',
      doan: p.dungVon || '',
      hang: p.cotMoc ? [['Cột mốc 12–18 tháng', p.cotMoc]] : [],
    });
  }
  if (khoiKq.length) {
    muc.push({ h: 'Số liệu doanh nghiệp tự tính', kieu: 'ketqua', khoi: khoiKq });
  }
  if (!guiRaNgoai && ((data && data.saved) || []).length) {
    muc.push({
      h: 'Nguồn vốn đang theo dõi',
      kieu: 'danh-sach',
      items: data.saved.map((s) => s.name),
    });
  }
  if (!guiRaNgoai) {
    muc.push({
      h: 'Việc cần làm',
      kieu: 'danh-sach',
      items: CONG_VIEC.map((t, i) => `${data?.tasks?.[i] ? '☑' : '☐'} ${t}`),
    });
  }

  return {
    guiRaNgoai,
    ngay,
    ten: p.companyName || 'Bản chuẩn bị gọi vốn',
    moTa: p.moTa || '',
    logo: p.logo || '',
    phuDe: [nhan('STAGE', p.roundType), nhan('INDUSTRY', p.industry), TEN_TP[p.city] || '']
      .filter(Boolean).join(', '),
    tuKhai: `Bản tự khai do doanh nghiệp lập ngày ${ngay}. Mọi số liệu do doanh nghiệp `
      + 'tự nhập và tự chịu trách nhiệm. Fundraising.vn cung cấp công cụ tính toán và '
      + 'không thẩm định, xác nhận hay xếp hạng doanh nghiệp nào.',
    goiVon: p.targetTy
      ? { soTien: `${p.targetTy} tỷ đồng`, vong: nhan('STAGE', p.roundType) }
      : null,
    muc,
    trong: !coBan.length && !khoiKq.length && !doiNgu.length && !p.moTa,
    chanTrang: [
      'Các con số dựa trên thông tin do doanh nghiệp nhập vào và giả định ghi trong '
      + 'từng công cụ. Đây không phải tư vấn đầu tư, tư vấn tài chính hay tư vấn pháp lý, '
      + 'không phải lời mời đầu tư, và không phải cam kết về kết quả gọi vốn.',
      'Người nhận nên tự thẩm định trước khi ra bất kỳ quyết định nào.'
      + (guiRaNgoai ? '' : ' Bản nội bộ, không gửi ra ngoài.'),
      ...(khoiKq.some((k) => k.nguon.loai === 'co-tai-lieu') ? [GIAI_THICH_TAI_LIEU] : []),
      'Lập bằng bộ công cụ miễn phí tại fundraising.vn',
    ],
  };
}

const GIAI_THICH_DIEM = 'Điểm do doanh nghiệp tự chấm theo bảng tiêu chí công khai tại '
  + 'fundraising.vn, dựa trên dữ liệu tự khai. Không phải đánh giá của bên thứ ba.';

function bangHtmlHang(hang) {
  return `<table>${hang.map(([k, v]) => `<tr><th scope="row">${thoat(k)}</th><td>${thoat(v)}</td></tr>`).join('')}</table>`;
}

function mucHtml(m, guiRaNgoai) {
  const than = m.kieu === 'bang' ? bangHtmlHang(m.hang)
    : m.kieu === 'danh-sach' ? `<ul>${m.items.map((i) => `<li>${thoat(i)}</li>`).join('')}</ul>`
      : m.kieu === 'hon-hop' ? `${m.doan ? `<p>${thoat(m.doan)}</p>` : ''}${m.hang.length ? bangHtmlHang(m.hang) : ''}`
        : m.khoi.map((k) => `<section class="kq-khoi"><h3>${thoat(k.ten)}</h3>`
          + `${k.nguon ? `<p class="nguon nguon-${k.nguon.loai}">${thoat(k.nguon.chu)}</p>` : ''}`
          + `${k.hang.length ? bangHtmlHang(k.hang) : ''}`
          + `${k.ghiChu.length ? `<ul class="ghi-chu">${k.ghiChu.map((g) => `<li>${thoat(g)}</li>`).join('')}</ul>` : ''}`
          + `${!guiRaNgoai && k.coDiem ? `<p class="ghi-chu">${GIAI_THICH_DIEM}</p>` : ''}</section>`).join('');
  return `<h2>${thoat(m.h)}</h2>${than}`;
}

/**
 * @param {object} data Bản chuẩn bị
 * @param {'nha-dau-tu'|'noi-bo'} [cheDo]
 */
export function dungHtmlMotTrang(data, cheDo = 'nha-dau-tu') {
  const n = noiDungMotTrang(data, cheDo);
  return `<!doctype html>
<html lang="vi"><head><meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1" />
<meta name="robots" content="noindex" />
<title>${thoat(n.ten)}: bản một trang</title>
<style>
  @page { size: A4; margin: 13mm; }
  *, *::before, *::after { box-sizing: border-box; }
  :root { --muc: #101216; --nhat: #626a78; --vien: #e3e6ec; --diem: #1b4dd8; }
  body {
    font: 10.5pt/1.55 "Segoe UI", -apple-system, Roboto, "Helvetica Neue", Arial, sans-serif;
    color: var(--muc); margin: 0 auto; padding: 28px 24px; max-width: 800px; background: #fff;
  }
  header { display: flex; gap: 18px; align-items: flex-start; }
  header img { max-height: 60px; max-width: 150px; object-fit: contain; flex: none; }
  .danh { flex: 1; min-width: 0; }
  h1 { font-size: 19pt; line-height: 1.2; margin: 0 0 4px; letter-spacing: -0.01em; }
  .mo-ta { font-size: 11.5pt; margin: 0 0 6px; }
  .phu-de { color: var(--nhat); margin: 0; font-size: 9.5pt; }
  .tu-khai {
    margin: 14px 0 0; padding: 7px 11px; border-left: 3px solid var(--diem);
    background: #f4f6fc; color: var(--nhat); font-size: 8.8pt; line-height: 1.45;
  }
  .goi-von {
    margin: 18px 0 0; padding: 12px 16px; border: 1px solid var(--vien);
    border-radius: 8px; display: flex; align-items: baseline; gap: 12px; flex-wrap: wrap;
  }
  .goi-von span { color: var(--nhat); font-size: 9pt; text-transform: uppercase; letter-spacing: .06em; }
  .goi-von strong { font-size: 15pt; }
  h2 {
    font-size: 9pt; text-transform: uppercase; letter-spacing: .09em; color: var(--nhat);
    margin: 22px 0 8px; padding-bottom: 5px; border-bottom: 1px solid var(--vien);
  }
  h3 { font-size: 10.5pt; margin: 14px 0 5px; }
  .nguon { margin: -2px 0 5px; font-size: 8.8pt; color: var(--nhat); }
  .nguon-co-tai-lieu { color: #2f6b4f; }
  table { width: 100%; border-collapse: collapse; }
  th, td { padding: 4px 0; text-align: left; font-weight: 400; vertical-align: top; }
  th { color: var(--nhat); width: 44%; padding-right: 12px; }
  td { font-variant-numeric: tabular-nums; }
  .kq-khoi { break-inside: avoid; }
  ul { margin: 4px 0 0; padding-left: 16px; }
  li { margin-bottom: 3px; }
  .ghi-chu { color: var(--nhat); font-size: 9.5pt; }
  footer { margin-top: 26px; padding-top: 10px; border-top: 1px solid var(--vien);
           color: var(--nhat); font-size: 8.5pt; line-height: 1.5; }
  footer p { margin: 0 0 4px; }
  @media print { body { padding: 0; } .khong-in { display: none; } }
</style></head>
<body>

<header>
  ${n.logo ? `<img src="${thoat(n.logo)}" alt="" />` : ''}
  <div class="danh">
    <h1>${thoat(n.ten)}</h1>
    ${n.moTa ? `<p class="mo-ta">${thoat(n.moTa)}</p>` : ''}
    ${n.phuDe ? `<p class="phu-de">${thoat(n.phuDe)}</p>` : ''}
  </div>
</header>

<p class="tu-khai">${thoat(n.tuKhai)}</p>

${n.goiVon ? `<div class="goi-von">
  <span>Đang gọi</span><strong>${thoat(n.goiVon.soTien)}</strong>
  ${n.goiVon.vong ? `<span>vòng ${thoat(n.goiVon.vong)}</span>` : ''}
</div>` : ''}

${n.muc.map((m) => mucHtml(m, n.guiRaNgoai)).join('\n')}

${n.trong ? '<p class="ghi-chu">Bản chuẩn bị chưa có dữ liệu. Hãy điền hồ sơ và chạy vài công cụ rồi xuất lại.</p>' : ''}

<footer>${n.chanTrang.map((c) => `<p>${thoat(c)}</p>`).join('')}</footer>

<script class="khong-in">
/* Mở kèm #in thì hiện luôn hộp thoại in; ai chỉ muốn đọc thì bấm Huỷ. */
if (location.hash === '#in') window.print();
</script>
</body></html>`;
}

function tenFile(data, duoi) {
  return tenFileAnToan(
    data.profile?.companyName ? `Ho-so-${data.profile.companyName}` : 'Ban-mot-trang',
    duoi,
  );
}

/** File HTML để tải về hoặc chia sẻ. */
export function fileMotTrang(data, cheDo) {
  return new File([dungHtmlMotTrang(data, cheDo)], tenFile(data, 'html'), {
    type: 'text/html;charset=utf-8',
  });
}

/**
 * Mở bản một trang ở tab mới kèm hộp thoại in — đó là đường ra PDF mà không
 * phải kéo thêm thư viện PDF nặng vài trăm KB.
 */
export function inMotTrang(data, cheDo) {
  const blob = new Blob([dungHtmlMotTrang(data, cheDo)], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const w = window.open(`${url}#in`, '_blank');
  if (!w) {
    URL.revokeObjectURL(url);
    throw new Error('Trình duyệt chặn cửa sổ mới. Hãy cho phép pop-up rồi thử lại.');
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

/** Trình duyệt có chia sẻ được file không (điện thoại thường có, máy tính thường không). */
export function chiaSeDuoc(file) {
  return Boolean(navigator.canShare && navigator.canShare({ files: [file] }));
}

/**
 * Chia sẻ qua trình chia sẻ của hệ điều hành: Zalo, Messenger, email, AirDrop.
 * Không hỗ trợ thì ném lỗi để bên gọi chuyển sang tải về.
 */
export async function chiaSeFile(file, tieuDe) {
  if (!chiaSeDuoc(file)) throw new Error('Thiết bị này chưa hỗ trợ chia sẻ file trực tiếp.');
  try {
    await navigator.share({ files: [file], title: tieuDe, text: tieuDe });
  } catch (e) {
    // Người dùng bấm huỷ không phải lỗi — đừng hiện thông báo đỏ vì chuyện đó.
    if (e?.name === 'AbortError') return;
    throw e;
  }
}
